import { render } from "./AppMenuBar.vue?vue&type=template&id=55f2ef9d&scoped=true"
import script from "./AppMenuBar.vue?vue&type=script&lang=js"
export * from "./AppMenuBar.vue?vue&type=script&lang=js"

import "@/Common/Styles/AppMenuBarStyles.scss?vue&type=style&index=0&id=55f2ef9d&lang=scss&scoped=true"
import "@/Common/Styles/UserBalanceAndAddress.scss?vue&type=style&index=1&id=55f2ef9d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f2ef9d"]])

export default __exports__